import Vue from 'vue'
import router from '../router'
// import axios from 'axios'
import qs from 'qs'
import {
  upload,
  post,
  postPay
} from './http.js'
export default class utils {
  /**
   * 获取url中的参数
   */
  static getQueryVariable (variable) { // 获取url中的参数
    var rs = decodeURI(window.location.search)
    var query = rs.substring(1)
    var vars = query.split('&')
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split('=')
      if (pair[0] == variable) {
        return pair[1]
      }
    }
    return null
  }
  /**
   * 判断字符串是否为空
   * @param str
   * @returns {boolean}
   */
  static isNull (str) {
    return str == null || str.length === 0 || str === ''
  }

  /**
   *
   * @desc  判断是否为身份证号
   * @param  {String|Number} str
   * @return {Boolean}
   */
  // static isIdCard(str) {
  //   return /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/
  //     .test(str)
  // }
  // 身份证验证
  static isIdCard (idcode) {
    // var idcard_patter =
    //   /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/;
    var idcard_patter = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X|x)$/
    // 判断格式是否正确
    var format = idcard_patter.test(idcode)
    if (format) {
      // 加权因子
      var weight_factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
      // 校验码
      var check_code = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']

      var code = idcode + ''
      var last = idcode[17].toUpperCase() // 最后一位

      var seventeen = code.substring(0, 17)

      // ISO 7064:1983.MOD 11-2
      // 判断最后一位校验码是否正确
      var arr = seventeen.split('')
      var len = arr.length
      var num = 0
      for (var i = 0; i < len; i++) {
        num = num + arr[i] * weight_factor[i]
      }

      // 获取余数
      var resisue = num % 11
      var last_no = check_code[resisue]

      // 格式的正则
      // 正则思路
      /*
      第一位不可能是0
      第二位到第六位可以是0-9
      第七位到第十位是年份，所以七八位为19或者20
      十一位和十二位是月份，这两位是01-12之间的数值
      十三位和十四位是日期，是从01-31之间的数值
      十五，十六，十七都是数字0-9
      十八位可能是数字0-9，也可能是X
      */

      // 返回验证结果，校验码和格式同时正确才算是合法的身份证号码
      return last === last_no
    } else {
      return false
    }
  }
  /**
   *
   * @desc   判断是否为手机号
   * @param  {String|Number} str
   * @return {Boolean}
   */
  static isPhone (phone) {
    return !(/^1[3|4|5|6|7|8|9][0-9]{9}$/.test(phone))
  }

  // 消息提示弹窗
  static msgshow (text, callback) {
    var div = document.createElement('div')
    div.setAttribute('id', 'msgshow')
    div.innerHTML = text
    document.getElementsByTagName('body')[0].appendChild(div)
    setTimeout(function () {
      var msgshow = document.getElementById('msgshow')
      document.getElementsByTagName('body')[0].removeChild(msgshow)
      if (callback) {
        callback()
      }
    }, 2000)
  }

  /* loading弹窗 */
  static openloading (text) {
    var div = document.createElement('div')
    div.setAttribute('id', 'loadingshow')
    div.innerHTML = text || ''
    document.getElementsByTagName('body')[0].appendChild(div)
  }
  static closeloading () {
    var load = document.getElementById('loadingshow')
    if (load) {
      document.getElementsByTagName('body')[0].removeChild(load)
    }
  }

  // alert弹窗
  static openAlert (context, callback) {
    var _this = this
    var html = '<div><p style="font-size:0.32rem;">提示</p><p>' + context + '</p><button>确定</button></div>'
    var div = document.createElement('div')
    div.setAttribute('id', 'alertshow')
    div.innerHTML = html
    document.getElementsByTagName('body')[0].appendChild(div)
    div.children[0].children[2].onclick = function () {
      callback ? callback() : _this.closeAlert()
    }
  }
  static closeAlert () {
    var alert = document.getElementById('alertshow')
    document.getElementsByTagName('body')[0].removeChild(alert)
  }

  static openAlert2 (context) {
    var html = '<div><p style="font-size:0.32rem;">提示</p><p>' + context + '</p>'
    var div = document.createElement('div')
    div.setAttribute('id', 'alertshow2')
    div.innerHTML = html
    document.getElementsByTagName('body')[0].appendChild(div)
  }

  // confirm弹窗
  static openConfirm (title, context, btntext1, btntext2, callback1, callback2, closeBtn, closeCallback) {
    closeBtn = closeBtn || ''
    var html = '<div id="confirmBox"><h6>' + title + '</h6><p>' + context + '</p><ul><li>' + btntext1 + '</li><li>' +
      btntext2 + '</li></ul><span id="closeBtns">' + closeBtn + '</span></div>'
    var confirm = document.createElement('div')
    confirm.setAttribute('id', 'confirm')
    confirm.innerHTML = html
    document.getElementsByTagName('body')[0].appendChild(confirm)
    confirm.children[0].children[2].children[0].onclick = function () {
      callback1()
    }
    confirm.children[0].children[2].children[1].onclick = function () {
      callback2()
    }
    $('#confirmBox').on('click', '#closeBtns', function () {
      document.getElementsByTagName('body')[0].removeChild(confirm)
      closeCallback()
    })
  }
  static closeConfirm () {
    var confirm = document.getElementById('confirm')
    document.getElementsByTagName('body')[0].removeChild(confirm)
  }

  /* 判断值为空、null、undefined等非有效值 */
  static isEmpty (sth) {
    return sth == '' || sth == undefined || sth == 'undefined' || sth == null || sth == 'null'
  }

  /* 生成唯一标识 */
  static uuid (len, radix) {
    var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
    var uuid = []
    var i
    radix = radix || chars.length
    if (len) {
      for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix]
    } else {
      var r
      uuid[8] = uuid[13] = uuid[18] = uuid[23] = ''
      uuid[14] = '4'
      for (i = 0; i < 36; i++) {
        if (!uuid[i]) {
          r = 0 | Math.random() * 16
          uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r]
        }
      }
    }
    return uuid.join('')
  }

  /* 判断图片大小和尺寸 */
  static checkPic (type, fileSize) {
    var picExts = 'jpg|jpeg|png|bmp|gif|webp'
    var pos = picExts.indexOf(type)
    if (pos < 0) {
      this.msgshow('您选中的文件不是图片，请重新选择')
      return false
    }
    fileSize = Math.round(fileSize / 1024 * 100) / 100 // 单位为KB
    if (fileSize > 30 * 1024) {
      this.msgshow('您选择的图片大小超过限制(最大为30M)，请重新选择')
      return false
    }
    return true
  }

  /**
   *
   * @desc   时间个位数的时候加0
   * @param  {String|Number} i
   */
  static addZera (i) {
    if (i < 10 && i >= 0) {
      i = '0' + i
    } else if (i < 0) {
      i = '00'
    }
    return i
  }
  /**
   *
   * @desc   上传图片 图片处理
   * @param （files-- e.taget.files ， 回调函数  ，最多可选的张数  不填不判断数量）
   */
  static imgPreviewUpload (files, callback, length, callbackProgress, isclose, callbackerror) {
    var file = files[0]
    let fileType = file.type
    var fileLen = files.length
    let _this = this
    if (length && fileLen != null && fileLen > length) {
      this.msgshow('最多可选' + length + '张')
    } else {
      if (/image\/\w+/.test(fileType)) {
        // if(file.size>2048){
        if (isclose != 'closeloading') {
          this.openloading('上传中')
        }
        let sendData = []
        for (var f = 0; f < fileLen; f++) {
          var files = files
          file = files[f]
          var orient
          EXIF.getData(file, function () {
            orient = EXIF.getTag(this, 'Orientation')
          })

          fileType = file.type
          var reader = new FileReader()
          reader.readAsDataURL(files[f])
          var blob = window.URL.createObjectURL(files[f]) // 转换为二进制blob文件
          var img = new Image()
          img.src = blob
          img.onload = function () {
            var cvs = document.createElement('canvas')
            var ctx = cvs.getContext('2d')
            var scale = 1
            var fileKb = parseInt(file.size / 1024)
            if (fileKb >= 200 && fileKb < 1000) {
              if (this.width > this.height) {
                scale = this.height / this.width
              } else {
                scale = this.width / this.height
              }
            } else if (fileKb >= 1000) {
              if (this.width > this.height) {
                scale = 1 - (this.height / this.width)
              } else {
                scale = 1 - (this.width / this.height)
              }
            }
            cvs.width = this.width
            cvs.height = this.height // 计算等比缩小后图片宽高
            ctx.fillStyle = '#fff'
            ctx.fillRect(0, 0, cvs.width, cvs.height)
            if (orient == 6 && (this.width > this.height)) {
              ctx.save()
              ctx.translate(this.width / 2, this.height / 2)
              ctx.rotate(90 * Math.PI / 180)
              ctx.drawImage(this, 0 - this.height / 2, 0 - this.width / 2, this.height, this.width)
              ctx.restore()
            } else {
              ctx.drawImage(this, 0, 0, this.width, this.height, 0, 0, cvs.width, cvs.height)
            }
            var newImageData = cvs.toDataURL('image/jpeg', scale)
            var _sendData = newImageData.replace('data:' + fileType + ';base64,', '')
            // input
            // file不能用于上传base64，所以要再加一个input，同时把当前file的input赋值空，防止原图片也上传
            sendData.push(newImageData)
            if (sendData.length == fileLen) {
              if (callbackProgress) {
                _this.uploadThum(file, callback, callbackProgress, isclose, callbackerror)
              } else {
                _this.uploadThum(sendData, callback)
              }
            }
          }
        }
      } else {
        this.closeloading()
        this.msgshow('请选择图片格式文件')
      }
    }
  }
  /**
   *
   * @desc   上传接口
   * @param （图片数组集合 , 回调函数）
   */
  static uploadThum (sendData, callback, callbackProgress, isclose, callbackerror) {
    let params = {
      imgFiles: sendData
    }

    function param (data) { // 整理参数的格式
      data.memberId = global.memberId
      return qs.stringify(data, {
        arrayFormat: 'brackets'
      })
    }
    if (!callbackProgress) {
      Vue.prototype.axios({
        method: 'POST',
        url: global.fileHref + '/ossFile/FileService/thumUpload',
        data: param(params)
      }).then((response) => {
        this.closeloading()
        if (response.data != null && response.data.urllist.length > 0) {
          this.msgshow('上传成功')
          if (callback) {
            callback(response.data.urllist)
          }
        } else {
          this.msgshow('上传失败')
        }
      })
    } else {
      var form = new FormData()
      form.append('file', sendData)
      form.append('dirName', 'syrjia/wzd')
      Vue.prototype.axios({
        method: 'POST',
        url: global.fileHref + '/ossFile/FileService/uploadImgFile',
        data: form,
        onUploadProgress: progressEvent => {
          var complete = (progressEvent.loaded / progressEvent.total * 100 | 0)
          callbackProgress(complete)
        }
      }).then((response) => {
        console.log(response)
        this.closeloading()
        if (response.data.respCode == 1001) {
          if (callback) {
            callback(response.data.data.result)
          }
        } else {
          if (callbackerror) {
            callbackerror(response.respMsg)
          }
        }
      })
    }
  }

  /**
   *
   * @desc   微信分享
   * @param parmas(url地址链接，title分享的标题，desc分享的描述，imgUrl分享的图片链接，success)
   */
  static wxShare (parmas) {
    // if(!parmas){
    var a = this.isWeiXinAndIos() ? window.localStorage.getItem('sigUrl') : window.location.href
    post('/im/queryScan.action', {
      url: a
    }).then(response => {
      if (response.data && response.respCode == 1001) {
        console.log('ddddddddddddddd')
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端openAlert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: response.data.appId, // 必填，公众号的唯一标识
          timestamp: response.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: response.data.nonceStr, // 必填，生成签名的随机串
          signature: response.data.signature, // 必填，签名，见附录1
          jsApiList: ['showMenuItems', 'hideAllNonBaseMenuItem', 'showAllNonBaseMenuItem', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo',
            'onMenuShareQZone', 'updateAppMessageShareData', 'updateTimelineShareData'
          ]
          // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        })

        wx.ready(function () {
          wx.showAllNonBaseMenuItem() // 显示所有功能按钮
          parmas.ready && parmas.ready()
          // 微信分享的数据
          var shareData = {
            'imgUrl': parmas.imgUrl ? parmas.imgUrl : 'https://mobile.syrjia.com/syrjia/img/logo.png', // 分享显示的缩略图地址
            'link': parmas.url ? parmas.url : window.location.href, // 分享地址
            'desc': parmas.desc ? parmas.desc : '上医明家', // 分享描述
            'title': parmas.title ? parmas.title : '上医明家', // 分享标题
            success: function () {
              parmas.success && parmas.success()
            }
          }
          // wx.updateAppMessageShareData(shareData) //自定义“分享给朋友”及“分享到QQ”按钮的分享内容
          // wx.updateTimelineShareData(shareData) //自定义“分享给朋友”及“分享到QQ”按钮的分享内容
          wx.onMenuShareTimeline(shareData)
          wx.onMenuShareAppMessage(shareData)
          wx.onMenuShareQQ(shareData)
          wx.onMenuShareWeibo(shareData)
          wx.onMenuShareQZone(shareData)
        })
        wx.error(function (res) {
          console.log(res)
        })
      }
    })
    // }else{
    //   var shareData = {
    //     'imgUrl': parmas.imgUrl ? parmas.imgUrl : 'https://mobile.syrjia.com/syrjia/img/logo.png', // 分享显示的缩略图地址
    //     'link': parmas.url ? parmas.url : window.location.href, // 分享地址
    //     'desc': parmas.desc ? parmas.desc : '上医明家', // 分享描述
    //     'title': parmas.title ? parmas.title : '上医明家', // 分享标题
    //     success: function() {
    //       parmas.success && parmas.success()
    //       alert("分享成功");
    //     }
    //   }
    //   // wx.updateAppMessageShareData(shareData) //自定义“分享给朋友”及“分享到QQ”按钮的分享内容
    //   // wx.updateTimelineShareData(shareData) //自定义“分享给朋友”及“分享到QQ”按钮的分享内容
    //   wx.onMenuShareTimeline(shareData)
    //   wx.onMenuShareAppMessage(shareData)
    //   wx.onMenuShareQQ(shareData)
    //   wx.onMenuShareWeibo(shareData)
    //   wx.onMenuShareQZone(shareData)
    //   parmas.payFn && parmas.payFn()
    // }
  }

  /**
   *
   * @desc   支付时调用
   * @param （支付方式 0微信/1支付报/3他人代付  , orderNo 订单号 ,）
   */
  static payFn (parmas) { // type, orderNo, dqwxerror 吊起微信时失败 ,wxsuccess 微信支付成功, wxerror微信支付失败, wxcancel 微信支付取消
    console.log(parmas)

    if (parmas.type == 0) {
      this.wxPay(parmas.orderNo, parmas.dqwxerror, parmas.wxsuccess, parmas.wxerror, parmas.wxcancel,'jsApi')
    } else if (parmas.type == 1) {
      this.zfbPay(parmas.orderNo)
    } else if (parmas.type == 2) {
      $('body').append(
        '<div class="sy_href"><img src="./static/sy_share2.png"></div>'
      )
      $('body').on('click', '.sy_href', item => {
        $('.sy_href').remove()
      })
    }
  }

  static payFnChannel (parmas) { // type, orderNo, dqwxerror 吊起微信时失败 ,wxsuccess 微信支付成功, wxerror微信支付失败, wxcancel 微信支付取消
    console.log(parmas)

    if (parmas.type == 0) {
      this.wxPay(parmas.orderNo, parmas.dqwxerror, parmas.wxsuccess, parmas.wxerror, parmas.wxcancel,'H5')
    } else if (parmas.type == 1) {
      this.zfbPay(parmas.orderNo)
    }/* else if (parmas.type == 2) {
      $('body').append(
        '<div class="sy_href"><img src="./static/sy_share2.png"></div>'
      )
      $('body').on('click', '.sy_href', item => {
        $('.sy_href').remove()
      })
    } */
  }

  /**
   *
   * @desc   微信支付
   * @param （orderNo 订单号 ,success,error ,wxcancel微信取消）
   */
  static isWeiXinAndIos () {
    // window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
    let ua = '' + window.navigator.userAgent.toLowerCase()
    // 通过正则表达式匹配ua中是否含有MicroMessenger字符串且是IOS系统
    let isWeixin = /MicroMessenger/i.test(ua) // 是在微信浏览器
    let isIos = /\(i[^;]+;( U;)? CPU.+Mac OS X/i.test(ua) // 是IOS系统
    return isIos
  }
  // 兼容部分ios手机input失焦后页面上移问题
  static isIos () {
    let myFunction
    let isWXAndIos = this.isWeiXinAndIos()
    if (isWXAndIos) { // 既是微信浏览器 又是ios============（因为查到只有在微信环境下，ios手机上才会出现input失去焦点的时候页面被顶起）
      document.body.addEventListener('focusin', () => { // 软键盘弹起事件
        clearTimeout(myFunction)
      })
      document.body.addEventListener('focusout', () => { // 软键盘关闭事件
        clearTimeout(myFunction)
        myFunction = setTimeout(function () {
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
          }) // 重点  =======当键盘收起的时候让页面回到原始位置
        }, 200)
      })
    }
  }

  static wxPay (orderNo, dqwxerror, success, error, wxcancel,_sign) {
    var _this = this
    var payUrl = '/wx/wxJsApiPay.action'
    /* if(_sign!=null&&_sign!=''&&_sign!=undefined&&_sign=='H5'){
      payUrl = '/wx/wxH5ApiPay.action'
    } */
    postPay(payUrl, {
      orderNo: orderNo
    }).then(response => {
      if (response.respCode == 1001) {
        callpay(response.data, success, error, wxcancel, dqwxerror,orderNo) // 调微信支付
      } else {
        _this.msgshow(response.respMsg, function () {
          dqwxerror && dqwxerror()
          // window.history.back();
        })
      }
    })

    function callpay (data, success, error, wxcancel, dqwxerror,_orderNo) {
      // 判断微信版本号
      var wechatInfo = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i)
      if (!wechatInfo) {
        _this.msgshow('此支付仅支持微信')
        dqwxerror && dqwxerror()
        return false
      } else if (wechatInfo[1] < '5.0') {
        _this.msgshow('本活动仅支持微信5.0以上版本')
        dqwxerror && dqwxerror()
        return false
      } else {
        if (typeof WeixinJSBridge === 'undefined') {
          if (document.addEventListener) {
            document.addEventListener(
              'WeixinJSBridgeReady',
              jsApiCall(data, success, error, wxcancel),
              false
            )
          } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', jsApiCall(data, success, error, wxcancel))
            document.attachEvent('onWeixinJSBridgeReady', jsApiCall(data, success, error, wxcancel))
          }
        } else {
          jsApiCall(data, success, error, wxcancel)
        }
      }
    }

    function jsApiCall (data, success, error, wxcancel) {
      console.log('进入微信支付 调起弹窗')
      var pack = eval('(' + data.finaPackage + ')')
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest', {
          appId: pack.appId, // 公众号名称，由商户传入
          timeStamp: pack.timeStamp, // 时间戳，自1970年以来的秒数
          nonceStr: pack.nonceStr, // 随机串
          package: pack.package,
          signType: pack.signType, // 微信签名方式：
          paySign: pack.paySign
          // 微信签名
        },
        function (res) {
          console.log('调起微信支付返回信息', res)
          if (res.err_msg == 'get_brand_wcpay_request:ok') {
            // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回
            /* queryWxOrderPayStatePost() */
            success && success()
          } else if (res.err_msg == 'get_brand_wcpay_request:cancel') {
            wxcancel && wxcancel()
          } else {
            console.log('支付失败 失败信息', res)
            error && error()
          }
        }
      )
    }

   /* function queryWxOrderPayStatePost('/wx/updateOrderState.action', {
      orderNo: orderNo
    }).then(response => {
      console.log("queryWxOrderPayStatePost"+response)
    }) */
  }
  /**
   *
   * @desc   支付宝
   * @param （支付方式 0微信/1支付报/3他人代付  , orderNo 订单号 ,）
   */
  static zfbPay (orderNo, success, error) {
    router.push('/pay_hint?orderNo=' + orderNo)
  }

  static checkName (text) {
    var reg = /[^\u4e00-\u9fa5a-zA-Z]/
    var reg2 = /^[\u4e00-\u9fa5]+$/
    function del (text) {
      var arr = text ? text.split('') : []
      for (var i = 0; i < arr.length; i++) {
        if (reg.test(arr[i])) {
          arr.splice(i, 1)
        }
      }
      return arr.join('')
    }
    function length (text) {
      var arr2 = text ? text.split('') : []
      var le = 0
      for (var i = 0; i < arr2.length; i++) {
        if (reg2.test(arr2[i])) {
          le += 2
        } else {
          le += 1
        }
        if (le > 30) {
          // $('#yzname').val(text.substr(0,i))
          return text.substr(0, i)
        }
      }
      return text.substr(0, i)
    }
    return length(del(text))
  }
  static checkNameState (text) {
    var reg = /[^\u4e00-\u9fa5a-zA-Z]/
    var reg2 = /^[\u4e00-\u9fa5]+$/
    function del (text) {
      var arr = text ? text.split('') : []
      for (var i = 0; i < arr.length; i++) {
        if (reg.test(arr[i])) {
          arr.splice(i, 1)
        }
      }
      return arr.join('')
    }
    function length (text) {
      var arr2 = text ? text.split('') : []
      var le = 0
      for (var i = 0; i < arr2.length; i++) {
        if (reg2.test(arr2[i])) {
          le += 2
        } else {
          le += 1
        }
        if (le > 30) {
          // $('#yzname').val(text.substr(0,i))
          return false
        }
      }
      return true
    }
    return length(del(text))
  }
  // 神策syrjPopupDisplay——上医明家_弹窗曝光
  static scPopupShow (tabTitle, _this) {
    _this.$sensors.track('syrjPopupDisplay', {
      msg_title: tabTitle, // 弹窗标题
      msg_content: ''// 弹窗id
    })
  }
  // 神策syrjPopupDisplay——上医明家_弹窗按钮点击
  static scPopupBtnClick (tabTitle, tabBtnEvent, _this) {
    _this.$sensors.track('syrjPopupClick', {
      msg_element_action: tabBtnEvent, // 弹窗按钮行为
      msg_title: tabTitle, // 弹窗标题
      msg_content: ''// 弹窗id
    })
  }
  static getIsJumpOld () { // 判断是否是重构项目跳转过来  返回true
    var jumpOld = this.getQueryVariable('jumpOld')
    if (window.sessionStorage.isJumpOld) {
      return true
    } else if (jumpOld == 1) {
      window.sessionStorage.isJumpOld = true
      return true
    }
    return false
  }
  static addSign (orderNo) { // 判断是否是重构项目跳转过来  返回true
    var data = {'orderNo': orderNo}
    data.timestamp = Math.ceil(new Date().getTime() / 1000)
    var newkey = Object.keys(data).sort()
    var newArr = [] // 创建一个新的对象，用于存放排好序的键值对
    for (var i = 0; i < newkey.length; i++) {
      // 遍历newkey数组
      if (data[newkey[i]]) {
        var text = newkey[i] + '=' + data[newkey[i]]
        newArr.push(text)
      }
    }
    newArr.push('key=4FC724FC8CB0D6CCBB04F50C18818F0B')
    var newObj = SparkMD5.hash(newArr.join('&'))
    var sign = newObj
    return 'orderNo=' + orderNo + '&sign=' + sign + '&timestamp=' + Math.ceil(new Date().getTime() / 1000)
  }

  // confirm信息确认弹窗
  static openConfirmNew (title, context, btntext1, btntext2, callback1, callback2, closeBtn, closeCallback) {
    closeBtn = closeBtn || ''
    var html = '<div id="confirmBoxNew"><h6>' + title + '</h6><p>' + context + '</p><ul><li>' + btntext1 + '</li><li>' +
      btntext2 + '</li></ul><span id="closeBtnsNew">' + closeBtn + '</span></div>'
    var confirm = document.createElement('div')
    confirm.setAttribute('id', 'confirm')
    confirm.innerHTML = html
    document.getElementsByTagName('body')[0].appendChild(confirm)
    confirm.children[0].children[2].children[0].onclick = function () {
      callback1()
    }
    confirm.children[0].children[2].children[1].onclick = function () {
      callback2()
    }
    $('#confirmBoxNew').on('click', '#closeBtnsNew', function () {
      document.getElementsByTagName('body')[0].removeChild(confirm)
      closeCallback()
    })
  }
  static closeConfirmNew () {
    var confirm = document.getElementById('confirm')
    document.getElementsByTagName('body')[0].removeChild(confirm)
  }

  // confirm就诊人填写信息及确认弹窗
  static openConfirmJZR (title, context, btntext1, btntext2, callback1, callback2, closeBtn, closeCallback) {
    closeBtn = closeBtn || ''
    var html = '<div id="confirmBoxJZR">' + '<div></div>' + '<p>' + context + '</p><ul><li>' + btntext1 + '</li><li>' +
      btntext2 + '</li></ul><span id="closeBtnsJZR">' + closeBtn + '</span></div>'
    var confirm = document.createElement('div')
    confirm.setAttribute('id', 'confirm')
    confirm.innerHTML = html
    document.getElementsByTagName('body')[0].appendChild(confirm)
    confirm.children[0].children[2].children[0].onclick = function () {
      callback1()
    }
    confirm.children[0].children[2].children[1].onclick = function () {
      callback2()
    }
    $('#confirmBoxJZR').on('click', '#closeBtnsJZR', function () {
      document.getElementsByTagName('body')[0].removeChild(confirm)
      closeCallback()
    })
  }
  /**
   * 表情过滤
   * @param {String} message
   * @returns string
   */
  static filterEmojiText (message = '') {
    const reg = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig
    message = message.replace(reg, '')
    return message
  }

  /**
   * 从18位证件证获取年龄和性别
   * @param {String} id 证件号码
   */
  static getAgeAndGenderFromId (id) {
    // 获取出生年月日
    const yearBirth = parseInt(id.substring(6, 10))
    const monthBirth = parseInt(id.substring(10, 12))
    const dayBirth = parseInt(id.substring(12, 14))

    // 获取当前年月日
    const myDate = new Date()
    const yearNow = myDate.getFullYear()
    const monthNow = myDate.getMonth() + 1 // JavaScript中月份从0开始，需要加1
    const dayNow = myDate.getDate()

    // 计算年龄
    let age = yearNow - yearBirth
    let monthStr = monthNow - monthBirth

    if (monthNow < monthBirth || (monthNow === monthBirth && dayNow < dayBirth)) {
      age--
    }

    if (monthNow < monthBirth) {
      monthStr = monthNow + 12 - monthBirth
    } else {
      monthStr = monthNow - monthBirth
    }

    if (monthStr === 0 && dayNow < dayBirth) {
      monthStr = 11
    }

    // 提取性别
    const genderCode = parseInt(id.substring(16, 17))
    const gender = genderCode % 2 === 0 ? '1' : '0'

    return { age, monthStr, gender }
  }

  /**
   * 判断是居民身份证和港澳台身份证生日超过当前
   */
  static validIdCardBirth (id) {
    // 获取出生年月日
    const yearBirth = parseInt(id.substring(6, 10))
    const monthBirth = parseInt(id.substring(10, 12))
    const dayBirth = parseInt(id.substring(12, 14))

    // 获取当前年月日
    const myDate = new Date()
    const yearNow = myDate.getFullYear()
    const monthNow = myDate.getMonth() + 1 // JavaScript中月份从0开始，需要加1
    const dayNow = myDate.getDate()

    // 检查出生日期是否晚于当前日期
    const birthDate = new Date(yearBirth, monthBirth - 1, dayBirth) // 注意：JavaScript中的月份从0开始
    const currentDate = new Date(yearNow, monthNow - 1, dayNow)

    if (birthDate > currentDate) {
      return false
    }
    return true
  }

  /**
   * 证件校验
   * @param {String} idCardNum 证件号码
   * @param {String} idCarType 证件类型
   * @returns boolean
   */
  static idCardValidate (idCardNum, idCarType) {
    const IdCardTypeEnum = {
      1: {
        name: '居民身份证',
        validate: (idCardNum) => {
          return this.isIdCard(idCardNum)
        }
      },
      2: {
        name: '军官证',
        validate: function (idCardNum) {
          return /^军\d{7}$/.test(idCardNum) // 检查"军"开头加7位数字
        }
      },
      3: {
        name: '港澳台居民居住证',
        validate: (idCardNum) => {
          return /^(810|820|830)000\d{11}([0-9]|X|x)$/.test(idCardNum) && this.isIdCard(idCardNum)
        }
      },
      4: {
        name: '港澳居民来往内地通行证',
        validate: function (idCardNum) {
          return /^[HMhm]\d{10}$/.test(idCardNum) // 检查H/M开头加10位数字
        }
      },
      5: {
        name: '台湾居民来往内地通行证',
        validate: function (idCardNum) {
          // 老格式：1位英文字符+7位数字编码
          const oldFormat = /^[a-zA-Z]\d{7}$/
          // 新格式：YYYYMMDD+2位数字编码
          const newFormat = /^[0-9]{4}(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])[0-9]{2}$/
          return oldFormat.test(idCardNum) || newFormat.test(idCardNum)
        }
      },
      6: {
        name: '护照',
        validate: function (idCardNum) {
          return idCardNum.trim().length > 0 // 任意非空字符串
        }
      },
      7: {
        name: '外国人永久居留证',
        validate: function (idCardNum) {
          // 既往15位，新规18位
          const oldFormat = /^[a-zA-Z]{3}[0-9]{12}$/
          const newFormat = /^\d{18}$/
          return oldFormat.test(idCardNum) || newFormat.test(idCardNum)
        }
      }
    }

    if (!IdCardTypeEnum[idCarType]) {
      return false
    }

    const idType = IdCardTypeEnum[idCarType]
    return idType.validate(idCardNum)
  }

  /**
   * 从台湾居民来往内地通行证号码中获取年龄
   * @param {String} idCardNum 台湾居民来往内地通行证号码
   * @returns {Object} { age, gender }
   */
  static getAgeAndGenderFromTWPassportCode (code) {
    // 提取出生日期
    const yearBirth = parseInt(code.substring(0, 4))
    const monthBirth = parseInt(code.substring(4, 6))
    const dayBirth = parseInt(code.substring(6, 8))

    // 获取当前年月日
    const myDate = new Date()
    const yearNow = myDate.getFullYear()
    const monthNow = myDate.getMonth() + 1 // JavaScript中月份从0开始，需要加1
    const dayNow = myDate.getDate()

    // 计算年龄
    let age = yearNow - yearBirth
    let monthStr = monthNow - monthBirth

    if (monthNow < monthBirth || (monthNow === monthBirth && dayNow < dayBirth)) {
      age--
    }

    if (monthNow < monthBirth) {
      monthStr = monthNow + 12 - monthBirth
    } else {
      monthStr = monthNow - monthBirth
    }

    if (monthStr === 0 && dayNow < dayBirth) {
      monthStr = 11
    }

    return { age, monthStr }
  }

  /**
   * 判断是居民身份证和港澳台身份证生日超过当前
   */
  static validTWPassportCodedBirth (code) {
    // 提取出生日期
    const yearBirth = parseInt(code.substring(0, 4))
    const monthBirth = parseInt(code.substring(4, 6))
    const dayBirth = parseInt(code.substring(6, 8))

    // 获取当前年月日
    const myDate = new Date()
    const yearNow = myDate.getFullYear()
    const monthNow = myDate.getMonth() + 1 // JavaScript中月份从0开始，需要加1
    const dayNow = myDate.getDate()

    // 检查出生日期是否晚于当前日期
    const birthDate = new Date(yearBirth, monthBirth - 1, dayBirth) // 注意：JavaScript中的月份从0开始
    const currentDate = new Date(yearNow, monthNow - 1, dayNow)

    if (birthDate > currentDate) {
      return false
    }
    return true
  }
}
// utils.isIos()



// WEBPACK FOOTER //
// ./src/utils/util.js